export const commonSchemasMap = {
    "tunein.clarity.ueapi.common.v1.Consent.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Consent.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "isApplicable": {
                "type": "boolean"
            },
            "status": {
                "enum": [
                    "CONSENT_STATUS_UNSPECIFIED",
                    "CONSENT_STATUS_GRANTED",
                    "CONSENT_STATUS_DENIED"
                ]
            }
        },
        "required": [
            "isApplicable",
            "status"
        ],
        "title": "Consent",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Vehicle.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Vehicle.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "drivingState": {
                "enum": [
                    "DRIVING_STATE_UNSPECIFIED",
                    "DRIVING_STATE_PARKED",
                    "DRIVING_STATE_IDLING",
                    "DRIVING_STATE_MOVING",
                    "DRIVING_STATE_UNKNOWN"
                ]
            },
            "isDistractionOptimizationRequired": {
                "type": "boolean"
            },
            "make": {
                "type": "string"
            },
            "model": {
                "type": "string"
            },
            "year": {
                "maximum": 4294967295,
                "minimum": 0,
                "type": "integer"
            }
        },
        "required": [
            "drivingState",
            "isDistractionOptimizationRequired",
            "make",
            "model",
            "year"
        ],
        "title": "Vehicle",
        "type": "object"
    },
    "google.protobuf.Timestamp.jsonschema.strict.json": {
        "$id": "google.protobuf.Timestamp.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "format": "date-time",
        "title": "Timestamp",
        "type": "string"
    },
    "tunein.clarity.ueapi.common.v1.ListeningInfo.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.ListeningInfo.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "guideId": {
                "type": "string"
            },
            "listenId": {
                "type": "string"
            },
            "parentGuideId": {
                "type": "string"
            }
        },
        "required": [
            "guideId",
            "listenId",
            "parentGuideId"
        ],
        "title": "Listening Info",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Os.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Os.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "name": {
                "type": "string"
            },
            "version": {
                "type": "string"
            }
        },
        "required": [
            "name",
            "version"
        ],
        "title": "Os",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.WaterfallLineItem.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.WaterfallLineItem.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "description": "Represents a single line item in an ad waterfall",
        "properties": {
            "errorCode": {
                "maximum": 2147483647,
                "minimum": -2147483648,
                "type": "integer"
            },
            "errorMessage": {
                "type": "string"
            },
            "isBidding": {
                "type": "boolean"
            },
            "latencyMsecs": {
                "maximum": 4294967295,
                "minimum": 0,
                "type": "integer"
            },
            "mediatedErrorCode": {
                "maximum": 2147483647,
                "minimum": -2147483648,
                "type": "integer"
            },
            "mediatedErrorMessage": {
                "type": "string"
            },
            "networkName": {
                "type": "string"
            },
            "placementId": {
                "type": "string"
            },
            "state": {
                "enum": [
                    "AD_LOAD_STATE_UNSPECIFIED",
                    "AD_LOAD_STATE_NOT_ATTEMPTED",
                    "AD_LOAD_STATE_LOADED",
                    "AD_LOAD_STATE_FAILED_TO_LOAD"
                ]
            }
        },
        "required": [
            "errorCode",
            "errorMessage",
            "isBidding",
            "latencyMsecs",
            "mediatedErrorCode",
            "mediatedErrorMessage",
            "networkName",
            "placementId",
            "state"
        ],
        "title": "Waterfall Line Item",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Page.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Page.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "path": {
                "type": "string"
            }
        },
        "required": [
            "path"
        ],
        "title": "Page",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.ProxyHeaders.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.ProxyHeaders.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "acceptLanguage": {
                "type": "string"
            },
            "userAgent": {
                "type": "string"
            },
            "xForwardedFor": {
                "type": "string"
            }
        },
        "required": [
            "acceptLanguage",
            "userAgent",
            "xForwardedFor"
        ],
        "title": "Proxy Headers",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.UserInfo.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.UserInfo.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "isLoggedIn": {
                "type": "boolean"
            },
            "isRegistered": {
                "type": "boolean"
            },
            "userId": {
                "type": "string"
            }
        },
        "required": [
            "isLoggedIn",
            "isRegistered",
            "userId"
        ],
        "title": "User Info",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Context.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Context.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "app": {
                "$ref": "tunein.clarity.ueapi.common.v1.App.jsonschema.strict.json"
            },
            "appState": {
                "$ref": "tunein.clarity.ueapi.common.v1.AppState.jsonschema.strict.json"
            },
            "deviceId": {
                "type": "string"
            },
            "ip": {
                "type": "string"
            },
            "listeningInfo": {
                "$ref": "tunein.clarity.ueapi.common.v1.ListeningInfo.jsonschema.strict.json"
            },
            "locale": {
                "type": "string"
            },
            "page": {
                "$ref": "tunein.clarity.ueapi.common.v1.Page.jsonschema.strict.json"
            },
            "partnerId": {
                "type": "string"
            },
            "privacy": {
                "$ref": "tunein.clarity.ueapi.common.v1.Privacy.jsonschema.strict.json"
            },
            "screen": {
                "$ref": "tunein.clarity.ueapi.common.v1.Screen.jsonschema.strict.json"
            },
            "sessionId": {
                "type": "string"
            },
            "timezone": {
                "type": "string"
            },
            "userAgent": {
                "type": "string"
            },
            "userInfo": {
                "$ref": "tunein.clarity.ueapi.common.v1.UserInfo.jsonschema.strict.json"
            },
            "vehicle": {
                "$ref": "tunein.clarity.ueapi.common.v1.Vehicle.jsonschema.strict.json"
            }
        },
        "required": [
            "app",
            "appState",
            "deviceId",
            "ip",
            "listeningInfo",
            "locale",
            "page",
            "partnerId",
            "privacy",
            "screen",
            "sessionId",
            "timezone",
            "userAgent",
            "userInfo",
            "vehicle"
        ],
        "title": "Context",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.BiddingNetwork.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.BiddingNetwork.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "isIncluded": {
                "type": "boolean"
            },
            "networkName": {
                "type": "string"
            },
            "requestId": {
                "type": "string"
            }
        },
        "required": [
            "isIncluded",
            "networkName",
            "requestId"
        ],
        "title": "Bidding Network",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.App.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.App.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "version": {
                "type": "string"
            }
        },
        "required": [
            "version"
        ],
        "title": "App",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.AppState.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.AppState.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "abTestIds": {
                "type": "string"
            },
            "inBackground": {
                "type": "boolean"
            }
        },
        "required": [
            "abTestIds",
            "inBackground"
        ],
        "title": "App State",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Network.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Network.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "bluetooth": {
                "type": "boolean"
            },
            "carrier": {
                "type": "string"
            },
            "cellular": {
                "type": "boolean"
            },
            "wifi": {
                "type": "boolean"
            }
        },
        "required": [
            "bluetooth",
            "carrier",
            "cellular",
            "wifi"
        ],
        "title": "Network",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Location.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Location.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "city": {
                "type": "string"
            },
            "country": {
                "type": "string"
            },
            "latitude": {
                "anyOf": [
                    {
                        "type": "number"
                    },
                    {
                        "type": "string"
                    }
                ]
            },
            "longitude": {
                "anyOf": [
                    {
                        "type": "number"
                    },
                    {
                        "type": "string"
                    }
                ]
            }
        },
        "required": [
            "city",
            "country",
            "latitude",
            "longitude"
        ],
        "title": "Location",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Screen.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Screen.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "height": {
                "maximum": 4294967295,
                "minimum": 0,
                "type": "integer"
            },
            "width": {
                "maximum": 4294967295,
                "minimum": 0,
                "type": "integer"
            }
        },
        "required": [
            "height",
            "width"
        ],
        "title": "Screen",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Device.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Device.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "batteryPct": {
                "maximum": 4294967295,
                "minimum": 0,
                "type": "integer"
            },
            "manufacturer": {
                "type": "string"
            },
            "model": {
                "type": "string"
            },
            "name": {
                "type": "string"
            },
            "type": {
                "type": "string"
            }
        },
        "required": [
            "batteryPct",
            "manufacturer",
            "model",
            "name",
            "type"
        ],
        "title": "Device",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.ServerContext.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.ServerContext.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "proxyHeaders": {
                "$ref": "tunein.clarity.ueapi.common.v1.ProxyHeaders.jsonschema.strict.json"
            }
        },
        "title": "Server Context",
        "type": "object",
        "required": [
            "proxyHeaders"
        ]
    },
    "tunein.clarity.ueapi.common.v1.Jurisdiction.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Jurisdiction.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "countryCode": {
                "type": "string"
            },
            "stateCode": {
                "type": "string"
            }
        },
        "required": [
            "countryCode",
            "stateCode"
        ],
        "title": "Jurisdiction",
        "type": "object"
    },
    "tunein.clarity.ueapi.common.v1.Privacy.jsonschema.strict.json": {
        "$id": "tunein.clarity.ueapi.common.v1.Privacy.jsonschema.strict.json",
        "$schema": "https://json-schema.org/draft/2020-12/schema",
        "additionalProperties": false,
        "properties": {
            "gdpr": {
                "$ref": "tunein.clarity.ueapi.common.v1.Consent.jsonschema.strict.json"
            },
            "globalOptIn": {
                "$ref": "tunein.clarity.ueapi.common.v1.Consent.jsonschema.strict.json"
            },
            "globalOptOut": {
                "$ref": "tunein.clarity.ueapi.common.v1.Consent.jsonschema.strict.json"
            },
            "jurisdictionDetails": {
                "$ref": "tunein.clarity.ueapi.common.v1.Jurisdiction.jsonschema.strict.json"
            },
            "lastUpdatedAt": {
                "$ref": "google.protobuf.Timestamp.jsonschema.strict.json"
            },
            "systemAdTrackingStatus": {
                "enum": [
                    "SYSTEM_AD_TRACKING_STATUS_UNSPECIFIED",
                    "SYSTEM_AD_TRACKING_STATUS_RESTRICTED",
                    "SYSTEM_AD_TRACKING_STATUS_DENIED",
                    "SYSTEM_AD_TRACKING_STATUS_AUTHORIZED"
                ]
            },
            "usPrivacy": {
                "$ref": "tunein.clarity.ueapi.common.v1.Consent.jsonschema.strict.json"
            }
        },
        "required": [
            "gdpr",
            "globalOptIn",
            "globalOptOut",
            "jurisdictionDetails",
            "lastUpdatedAt",
            "systemAdTrackingStatus",
            "usPrivacy"
        ],
        "title": "Privacy",
        "type": "object"
    }
};
